define('gameInterfaces/pages/QuickspinGameInterface',['knockout', 'underscore'], function(ko, _) {

    /**
     * Note. Its game runner is called relax
     */
    function QuickspinGameInterface(RealityCheckViewModel, navigation) {

        var self = this,
            source = window.parent;

        self.realityCheckViewModel = new RealityCheckViewModel(self);

        self.canActivate = function() {
            return self.realityCheckViewModel.canActivate();
        };

        self.continuePlaying = function() {
            notifyGame('resumeGame');
        };

        self.exitToLobby = function() {

            notifyGame('navigateTo', {
                url: navigation.reverseRouteAbsolute(navigation.ROUTES.GAMES)
            });
        };

        self.exitToGameRoundHistory = function() {

            notifyGame('navigateTo', {
                url: navigation.reverseRouteAbsolute(navigation.ROUTES.HISTORY_BETS)
            });
        };

        self.compositionComplete = function() {

            self.realityCheckViewModel.realityCheck.subscribe(_.skipFalsy(function() {
                notifyGame('pauseGame', { callback: 'gamePaused', return_data: [] });
            }));

            window.addEventListener(
                'message',
                handleReceivedMessage,
                false
            );

            notifyGame('operatorLoaded');

        };

        function notifyGame(method, params) {

            source.postMessage(
                {
                    method: method,
                    params: params
                },
                '*'
            );
        }

        function handleReceivedMessage(e) {

            switch (e.data.method) {
                case 'gameLoadedHandler':
                    break;

                case 'gamePaused':
                    // No need to do anything
                    break;
            }
        }

    }

    return QuickspinGameInterface;

});

